import Vue from 'vue';
import VueRouter from 'vue-router';
import Card from '../pages/Card.vue';
import Chat from '../pages/Chat.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    name: 'Card',
    component: Card
  },
  {
    path: '/chat',
    name: 'Chat',
    component: Chat,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

export default router;